import React from 'react';
import { Share, PlusSquare, Check, MoreVertical, Download, Smartphone } from 'lucide-react';
import './RyanPwaInstallGuide.css';

export type RyanDeviceOS = 'ios' | 'android' | 'other';

/** iPadOS 13+ se identifica como "Macintosh" no userAgent, mas tem touch —
    diferencia de um Mac de verdade (sem touch) pra ainda cair no fluxo iOS. */
export function detectDeviceOS(): RyanDeviceOS {
  if (typeof navigator === 'undefined') return 'other';
  const ua = navigator.userAgent || '';
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
  if (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1) return 'ios';
  if (/Android/i.test(ua)) return 'android';
  return 'other';
}

export function isRunningStandalone(): boolean {
  if (typeof window === 'undefined') return false;
  const nav = window.navigator as Navigator & { standalone?: boolean };
  return window.matchMedia?.('(display-mode: standalone)').matches || nav.standalone === true;
}

interface Step {
  icon: React.ComponentType<{ size?: number }>;
  text: string;
}

const IOS_STEPS: Step[] = [
  { icon: Share, text: 'Toque no ícone de compartilhar (o quadrado com a seta) na barra do Safari.' },
  { icon: PlusSquare, text: 'Role as opções e toque em "Adicionar à Tela de Início".' },
  { icon: Check, text: 'Toque em "Adicionar" no canto superior direito. Pronto!' },
];

const ANDROID_STEPS: Step[] = [
  { icon: MoreVertical, text: 'Toque nos três pontinhos no canto superior direito do Chrome.' },
  { icon: Download, text: 'Toque em "Adicionar à tela inicial" (ou "Instalar app", se aparecer).' },
  { icon: Check, text: 'Confirme. Pronto!' },
];

interface RyanPwaInstallGuideProps {
  /** Título curto acima do passo a passo — cada tela de uso reescreve com o
      tom que combina com o contexto (pós-cadastro vs banner). */
  heading?: string;
}

const RyanPwaInstallGuide: React.FC<RyanPwaInstallGuideProps> = ({ heading }) => {
  const os = detectDeviceOS();

  if (os === 'other') {
    return (
      <div className="rpig-desktop-note">
        <Smartphone size={18} />
        <span>Recomendamos acessar pelo celular pra instalar como app.</span>
      </div>
    );
  }

  const steps = os === 'ios' ? IOS_STEPS : ANDROID_STEPS;

  return (
    <div className="rpig-wrap">
      {heading && <p className="rpig-heading">{heading}</p>}
      <ol className="rpig-steps">
        {steps.map((step, i) => {
          const Icon = step.icon;
          return (
            <li key={i} className="rpig-step">
              <span className="rpig-step-icon"><Icon size={17} /></span>
              <span className="rpig-step-text">{step.text}</span>
            </li>
          );
        })}
      </ol>
    </div>
  );
};

export default RyanPwaInstallGuide;
